export default __webpack_public_path__ + "static/media/Employee_ID.12f40712.svg";